import hexRgb from 'hex-rgb'

export const formatHexToEsriRgb = (color: string): number[] => {
  const rgb = hexRgb(color, { format: 'array' })

  rgb[3] *= 255

  return rgb
}
